import { MultiLegShippingEmissionEstimate } from '@lune-climate/lune'
import {
    CalculationResults,
    flattenLegs,
    Leg,
    LegsPdfTable,
    PdfContent,
} from '@lune-fe/lune-components-lib'
import { Container } from '@lune-fe/lune-ui-lib'
import { Stack } from '@mui/material'
import { FC, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getEstimates } from 'endpoints/api'
import useTitle from 'hooks/useTitle'
import { EstimateTypeEnum, EstimateTypeName } from 'views/CalculateEmissions'
import MultiLegEstimate from 'views/CalculateEmissions/MultiLegLogistics/MultiLegEstimate'

const MultiLegLogisticsResultsPdf: FC = () => {
    useTitle('Multi-leg Logistics Emissions Results')
    const { id, token } = useParams<{ id: string; token: string }>()
    const [estimate, setEstimate] = useState<MultiLegShippingEmissionEstimate>()

    useEffect(() => {
        if (!id || !token || !!estimate) {
            return
        }
        getEstimates(id, token).then((estimate) => {
            setEstimate(estimate)

            // window.loadingPdf = 'loaded' will be passed to pdf endpoint to  make sure
            // everything renders before generating the pdf
            setTimeout(() => {
                window.loadedPdf = 'loaded'
            }, 500)
        })
    }, [id])

    const legs: Leg[] = useMemo(() => {
        if (!estimate?.legs) {
            return []
        }
        return flattenLegs(estimate)
    }, [estimate])

    return (
        <Container
            maxWidth={'md'}
            sx={{
                my: 9,
                px: {
                    xs: 2,
                    sm: 2,
                    md: 2,
                    lg: 0,
                    xl: 0,
                },
            }}
        >
            <PdfContent>
                {estimate && (
                    <>
                        <CalculationResults
                            pdfStructure={true}
                            title={
                                estimate.request.name ||
                                EstimateTypeName(EstimateTypeEnum.MULTI_LEG_SHIPPING)
                            }
                            amount={estimate.mass.amount}
                            dataQualityScore={estimate.dataQualityScore?.score}
                        />

                        <Stack direction={'column'} spacing={9} mt={9}>
                            <LegsPdfTable legs={legs} />
                            <MultiLegEstimate
                                pdfStructure={true}
                                legs={legs}
                                load={estimate.request.shipment}
                                source={estimate.source}
                            />
                        </Stack>
                    </>
                )}
            </PdfContent>
        </Container>
    )
}

export default MultiLegLogisticsResultsPdf
